import { useNavigate } from 'react-router-dom';

import {
  LoginForm,
  LoginFormValues,
} from '../../components/organisms/login-form/login-form';
import { useAuth } from '../../hooks/use-auth';
import {
  Card,
  Divider,
  Eyebrow,
  Footer,
  Header,
  Subtitle,
  Title,
} from './login.styles';

export const LoginPage = () => {
  const navigate = useNavigate();
  const { login, isLoading, error, clearError } = useAuth();

  const handleSubmit = async (values: LoginFormValues) => {
    try {
      await login(values);
      navigate('/', { replace: true });
    } catch {
      // erro já está exposto via `error` do hook
    }
  };

  return (
    <Card>
      <Header>
        <Eyebrow>Backoffice</Eyebrow>
        <Title>Entrar na plataforma</Title>
        <Subtitle>
          Acesse o painel interno da Vendepay usando seu e-mail corporativo.
        </Subtitle>
      </Header>

      <LoginForm
        onSubmit={handleSubmit}
        serverError={error}
        isLoading={isLoading}
        onDismissError={clearError}
      />

      <Footer>
        Acesso restrito a usuários autorizados.
        <Divider>•</Divider>
        Vendepay {new Date().getFullYear()}
      </Footer>
    </Card>
  );
};
